import { render, staticRenderFns } from "./CustomDropDown.vue?vue&type=template&id=1be23e38"
import script from "./CustomDropDown.vue?vue&type=script&lang=js"
export * from "./CustomDropDown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports